import { styled } from "@mui/styles";

export const Div = styled('div')({});